module.exports = __webpack_public_path__ + "static/media/Magician.4dc1eaa2.jpg";